import type { ReactNode } from 'react';
import { getErrorMessage } from '@/shared/api/client';

export function FullPageLoader({ label = 'Đang tải' }: { label?: string }) {
  return (
    <main className="center-page" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </main>
  );
}

export function InlineError({ error, action }: { error: unknown; action?: ReactNode }) {
  return (
    <div className="notice notice-error" role="alert">
      <span className="material-icons-round" aria-hidden="true">
        error_outline
      </span>
      <div className="notice-content">
        <strong>Không thể hoàn tất</strong>
        <span>{getErrorMessage(error)}</span>
      </div>
      {action}
    </div>
  );
}

export function EmptyState({
  icon,
  title,
  description,
}: {
  icon: string;
  title: string;
  description: string;
}) {
  return (
    <div className="empty-state">
      <span className="material-icons-round empty-icon" aria-hidden="true">
        {icon}
      </span>
      <strong>{title}</strong>
      <p>{description}</p>
    </div>
  );
}
